import type { TenantFeatures } from "../types";

export const motiveFeatures: TenantFeatures = {
  use_shared_lp_home_page: false,
  reporting_homepage_carried_interest: false,
  reporting_capital_activity_page: false,
  reporting_settings_investments: false,
  reporting_settings_notifications_notification: false,
  reporting_documents_investment_tab: false,
  reporting_homepage_investment: false,
  reporting_homepage_recent_activity: false,
  reporting_homepage_registered_products: false,
  reporting_homepage_leverage_investments: false,
  reporting_homepage_loan_application: false,
  reporting_homepage_restricted_investments: false,
  reporting_homepage_pending_actions: false,
  reporting_homepage_waterfall_charts: false,
  reporting_gp_anaytics_user_capital_activity: false,
  reporting_gp_fund_investments_tab: false,
  reporting_gp_fund_carried_interest_tab: false,
  reporting_gp_fund_capital_activity_tab: false,
  reporting_gp_impersonation_notification_tab: false,
  reporting_gp_organizations_investments_column: false,
  reporting_gp_organizations_deepdive_investments_tab: false,
  reporting_gp_organizations_deepdive_loan_application: false,
  reporting_gp_settings_cas_tab: false,
  reporting_gp_settings_cas_management: false,
  analytics_gp_page: false,
  lp_offerings_skip_listing_page: true,
  lp_offerings_hide_empty_columns: true,
  lp_offerings_show_opportunity_name: true,
  lp_show_navbar: false,
  funds_tabs_disclosure_disclaimers: true,
  funds_investor_eligibility_field: false,
  funds_vintage_performance_gross_metrics: false,
  funds_hide_vehicle_switcher_single_option: true,
  subscription_non_employee_legal_entities_enabled: true,
  gp_sanity_cms_enabled: false, // Motive uses local CMS, not Sanity
  auth_okta_login_flow: false,
  ingestion_import_data_funds: false,
  ingestion_import_data_organizations: true,
  ingestion_import_data_investing_legal_entities: false,
  ingestion_import_data_investments: false,
  ingestion_import_data_opportunities: true,
  ingestion_import_data_investor_documents: false,
  ingestion_import_data_investment_metrics: false,
  ingestion_import_data_users: true,
  ingestion_import_data_user_roles: true,
  ingestion_import_data_capital_activity: false,
  ingestion_import_data_capital_activity_cash_flow: false,
  ingestion_import_data_wire_instruction: true,
  ingestion_id_manager_funds: false,
  ingestion_id_manager_organizations: true,
  ingestion_id_manager_investing_legal_entities: false,
  ingestion_id_manager_investments: false,
  ingestion_id_manager_opportunities: true,
  ingestion_id_manager_investor_documents: false,
  ingestion_id_manager_wire_instructions: false,
  ingestion_id_manager_users: true,
  ingestion_id_manager_capital_activities: false,
  ingestion_id_manager_investment_metrics: false,
  ingestion_id_manager_user_roles: true,
  gp_parent_organization_redirect_to_investments: false,
  gp_co_investment_page: false,
  gp_cases_page: false,
  gp_entity_relationship_graph_page: false,
  gp_workbench_changelog_tab: false,
  gp_fund_opportunities_page_v2: true,
  gp_opportunity_management_edit_enabled: true,
  gp_opportunity_multi_invite_enabled: true,
  gp_co_investment_update_salesforce_data: false,
  lp_home_performance_investment_level: false,
  branding_show_powered_by_vega: false,
};
